import type { ColorFamily } from '@repo/api-contracts';

// 라벨은 계약(catalog.ts)이 단일 원천 — 기존 소비처의 import 경로를 위해 재노출한다.
export { COLOR_FAMILY_LABELS } from '@repo/api-contracts';

/** 색상 옵션 폼의 한 행. */
export interface ColorRowValues {
  /** 기존 행의 서버 id. RHF 의 fieldArray key(id)와 충돌하지 않게 별도 이름을 쓴다. */
  readonly optionId?: string;
  readonly name: string;
  readonly colorCode: string;
  readonly colorFamily: ColorFamily;
  readonly isAvailable: boolean;
  readonly previewImageKey: string | null;
}

export interface ColorFormValues {
  readonly colorOptions: ColorRowValues[];
}

export const NEW_COLOR_ROW: ColorRowValues = {
  name: '',
  colorCode: '#000000',
  colorFamily: 'BLACK',
  isAvailable: true,
  previewImageKey: null,
};
